import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './assets/styles/main.css'

// Initialize theme before mount
const initTheme = () => {
  const THEME_STORAGE_KEY = 'blog-theme'
  const stored = localStorage.getItem(THEME_STORAGE_KEY)

  if (stored === 'dark') {
    document.documentElement.classList.add('dark')
  } else if (!stored) {
    // Check system preference
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    if (prefersDark) {
      document.documentElement.classList.add('dark')
    }
  }
}

initTheme()

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.mount('#app')
